import { render, staticRenderFns } from "./confirmation-pages-layout.vue?vue&type=template&id=b14e3386"
import script from "./confirmation-pages-layout.vue?vue&type=script&lang=js"
export * from "./confirmation-pages-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports